import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TAGCALGR extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAG CAL GR</h1>
        </header>

        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.2292 (E) Dated 26-05-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (7) Mixture of Humic acid and Seaweed extract (Granules)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Kappaphycus alvarezii and Sargassum swartzii in ratio of 1:1; extract per cent. by weight, minimum: 3.3</li>
                <li>(ii) Humic acid powder as potassium humate (Source: Leonardite) per cent. by weight, minimum: 1.0</li>
                <li>(iii) Dolomite per cent. by weight, maximum: 95.7</li>
                <li>(iv) Total: 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Tomato</li>
            <li><span className="label">5. Doses:</span> 
              <ul>
                <li>Tomato: Two soil applications at 25 kg/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.2292 (ई) दिनांक 26-05-2025</li>
            <li><span className="label">2. जैवउत्तेजक का शीर्षक:</span> (7) ह्यूमिक अम्ल और समुद्री शैवाल सत्व का मिश्रण (कणिकाएँ)</li>
            <li><span className="label">3. संघटन:</span>
              <ul>
                <li>(i) कप्पाफाइकस सल्वारेज़ि और सारगासम स्वार्ट्ज़ि अनुपात 1:1; सत्व प्रतिशत भार के अनुसार, न्यूनतम: 3.3</li>
                <li>(ii) ह्यूमिक अम्ल चूर्ण पोटेशियम ह्यूमेट के रूप में (स्रोत: लियोनार्डाइट) प्रतिशत भार के अनुसार, न्यूनतम: 1.0</li>
                <li>(iii) डोलोमाइट प्रतिशत भार के अनुसार, अधिकतम: 95.7</li>
                <li>(iv) कुल: 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> टमाटर</li>
            <li><span className="label">5. मात्रा:</span> 
              <ul>
                <li>टमाटर: 25 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में प्रयोग</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> एस.ओ.२२९२ (ई) दिनांक २६-०५-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (७) ह्युमिक आम्ल आणि समुद्री शैवाल अर्क (ग्रॅन्यूल) यांचे मिश्रण</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) कप्पाफायकस साल्व्हेरेझिया आणि सरगासम स्वर्ट्झिया १:१ चे प्रमाण; अर्क टक्केवारी वजनाने, किमान: ३.३</li>
                <li>(ii) ह्युमिक आम्ल पावडर पोटॅशियम ह्युमेट म्हणून (स्रोत: लिओनार्डाइट) टक्केवारी वजनाने, किमान: १.०</li>
                <li>(iii) डोलोमाइट टक्केवारी वजनाने, कमाल: ९५.७</li>
                <li>(iv) एकूण: १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> टोमॅटो</li>
            <li><span className="label">५. मात्रा:</span> 
              <ul>
                <li>टोमॅटो: २५ किलो/हेक्टर दराने दोन मातीचे वापर</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    )
  }
}
